<template>
  <main class="mode-page">
    <header class="top">
      <div class="top-glow"></div>
      <div class="tabs">
        <span class="tab active">联网模式</span>
        <span class="tab" @click="$router.push({name:'devicelocal',query:{iccid:imei}})">本地模式</span>
      </div>
    </header>

    <section class="status-card card">
      <div class="status-item"><img src="./static/images/service-mode/Frame-1.png" alt=""><span>电量{{ deviceInfo.battery || 0 }}%</span></div>
      <div class="status-item"><img src="./static/images/service-mode/Frame.png" alt=""><span>设备连接 {{ deviceInfo.client_number || 0 }}</span></div>
      <div class="status-item"><img src="./static/images/service-mode/Frame-2.png" alt=""><span>{{ deviceInfo.isonline ? "在线" : "离线" }}</span></div>
    </section>

    <section class="block">
      <h2>设备设置</h2>
      <div class="card setting-card">
        <div class="row row-input"><span>WiFi名称：</span><input class="wifi-input" type="text" v-model="editSsid.ssid" :placeholder="deviceInfo.ssid"></div>
        <div class="row row-input"><span>WiFi密码：</span><input class="wifi-input" type="text" v-model="editSsid.key" :placeholder="deviceInfo.key"><button @click="saveSsid">保存</button></div>
        <div class="row"><span>设备重启</span><button @click="restart">重启</button></div>
        <div class="row"><span>设备恢复出厂设置</span><button @click="reset">重置</button></div>
      </div>
    </section>

    <section class="block">
      <h2>网络切换</h2>
      <div class="card net-card">
        <button
          v-if="deviceInfo.dianxin && (operator.netType===2 || operator.netType===5 || operator.netType===6 || operator.netType===0)"
          class="net-btn"
          :class="{active:deviceInfo.simIndex===0}"
          @click="qieka(0)"
        >
          中国电信
        </button>
        <button
          v-if="deviceInfo.liantong && (operator.netType===3 || operator.netType===5 || operator.netType===7 || operator.netType===0)"
          class="net-btn"
          :class="{active:deviceInfo.simIndex===1}"
          @click="qieka(1)"
        >
          中国联通
        </button>
        <button
          v-if="deviceInfo.yidong && (operator.netType===4 || operator.netType===6 || operator.netType===7 || operator.netType===0)"
          class="net-btn"
          :class="{active:deviceInfo.simIndex===2}"
          @click="qieka(2)"
        >
          中国移动
        </button>
        <button
          v-if="operator.netType===0 || operator.netType>4"
          class="net-btn"
          :class="{active:deviceInfo.simIndex===99}"
          @click="qieka(99)"
        >
          智能选网
        </button>
      </div>
    </section>

    <section class="block">
      <h2>设备信息</h2>
      <div class="card info-card">
        <div class="row"><span>卡号：</span><span>{{ deviceInfo.iccid }}</span></div>
        <div class="row"><span>信号强度：</span><span>{{ deviceInfo.rsrp }}dbm 良好</span></div>
        <div class="row"><span>imei码：</span><span>{{ deviceInfo.imei }}</span></div>
        <div class="row"><span>sn：</span><span>{{ deviceInfo.sn }}</span></div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "deviceNew",
  data () { return { imei: "", deviceInfo: {}, editSsid: { ssid: "", key: "" }, operator: {} } },
  methods: {
    getDeviceInfo () {
      this.$toast.loading({ duration: 0 })
      this.fetchData("/card/deviceInfo", { iccid: this.imei }, (res) => {
        this.$toast.clear()
        this.deviceInfo = res.data || {}
      })
    },
    restart () {
      if (!this.deviceInfo.isonline) return this.$toast("请先让设备联网在线")
      this.$toast.loading({ message: "发送中" })
      this.fetchData("/card/restartDevice", { iccid: this.imei }, (res) => { this.$toast.clear(); this.$toast(res.msg) })
    },
    reset () {
      if (!this.deviceInfo.isonline) return this.$toast("请先让设备联网在线")
      this.$dialog.confirm({ title: "提示", message: "确认将设备恢复到出厂状态？" }).then(() => {
        this.$toast.loading({ message: "发送中" })
        this.fetchData("/card/resetDevice", { iccid: this.imei }, (res) => { this.$toast.clear(); this.$toast(res.msg) })
      })
    },
    saveSsid () {
      if (!this.deviceInfo.isonline) return this.$toast("请先让设备联网在线")
      if (!this.editSsid.ssid || !this.editSsid.key) return this.$toast("请输入WiFi名称和密码")
      this.$toast.loading({ message: "设置中", forbidClick: true })
      this.fetchData("/card/savessid", { iccid: this.imei, ssid: this.editSsid.ssid, key: this.editSsid.key }, (res) => {
        this.$toast.clear()
        this.$toast(res.msg)
      })
    },
    qieka (index) {
      if (index === this.deviceInfo.simIndex) return
      this.$toast.loading({ message: "设置中", forbidClick: true })
      this.fetchData("/card/shuangkaqieka", { iccid: this.imei, simIndex: index }, (res) => {
        this.$toast.clear()
        this.$toast(res.msg)
        if (res.code) this.deviceInfo.simIndex = index
      })
    }
  },
  created () {
    this.imei = this.$route.query.iccid
    this.getDeviceInfo()
    this.fetchData("/card/cardOperator", { iccid: this.imei }, (res) => { if (res.code) this.operator = res.data })
  }
}
</script>

<style scoped src="./static/css/service-mode-a.css"></style>



// WEBPACK FOOTER //
// src/newpage/device.vue